import React from 'react';

const LoadingState = ({ 
  message = 'Loading...', 
  duration = null 
}) => {
  return (
    <div className="loading-state">
      <div className="loading-state-content">
        <div className="loading-state-spinner" />
        <p className="loading-state-message">{message}</p>
      </div>
    </div>
  );
};

export default LoadingState;